import { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

export function AnimatedFloorMaterial({
  color,
  type = "standard",
  transitionSpeed = 6,
  ...rest
}) {
  const materialRef = useRef(null);
  const targetColor = useRef(new THREE.Color(color));

  useEffect(() => {
    targetColor.current.set(color);
  }, [color]);

  useFrame((state, delta) => {
    const m = materialRef.current;
    if (!m?.color) return;
    const alpha = 1 - Math.exp(-transitionSpeed * delta);
    const prev = m.color.clone();
    m.color.lerp(targetColor.current, alpha);
    const moved =
      Math.abs(m.color.r - prev.r) +
      Math.abs(m.color.g - prev.g) +
      Math.abs(m.color.b - prev.b);
    if (moved > 0.0002) state.invalidate();
  });

  if (type === "basic") {
    return <meshBasicMaterial ref={materialRef} color={color} attach="material" {...rest} />;
  }

  return <meshStandardMaterial ref={materialRef} color={color} attach="material" {...rest} />;
}
